export default data => {
  return {
    '@type': 'SearchResultsPage',
    name: data?.title,
    description: data?.description,
    inLanguage: 'English',
    url: data?.canonicalUrl,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${data?.url}?search={query}`,
      query: 'required',
    },
  };
};
